import axios, { AxiosInstance, AxiosRequestConfig } from "axios";
import store from "../store";
import { FLOW_BACKEND_BASE_URL } from "./config";

// Create an Axios instance for the Vortex API
const axiosVortex: AxiosInstance = axios.create({
  baseURL: `${FLOW_BACKEND_BASE_URL}`,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add a request interceptor to include the Authorization header
axiosVortex.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    try {
      const token = store.getState().authUser?.user?.access_token; 
      if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    } catch (error) {
      console.error("Error setting authorization header:", error);
      return config;
    }
  },
  (error) => {
    console.error("Request interceptor error:", error);
    return Promise.reject(error);
  }
);

export default axiosVortex;
